/* CODE SUMARY
This code defines several arrays and objects used to calculate and add specific product packages to a cart in a Shopify store. The code begins by defining the SKU codes for different types of installation and service packages. It then defines ranges and corresponding codes for each type of installation and service package, as well as a map that connects each type of package to its corresponding SKU codes and ranges.

The code then defines several functions that are used to check the contents of a user's cart and find the relevant package to add to the cart based on the quantities of certain products in the cart. These functions include checkCartContents, which checks if the user's cart already contains a package from a given range; checkCartQuantities, which checks the quantities of specific products in the cart and finds the relevant package based on those quantities; and findRelevantPackage, which is used by checkCartQuantities to actually find the relevant package.

Finally, the code defines a function addToCart that is used to actually add the relevant package(s) to the cart. This function creates an array of package objects that includes the ID and quantity of each package to add, removes any duplicate packages from the array, and then sends a request to the Shopify API to add the packages to the cart.

addNewPackageToCart and updatePackagesOnCartUpdates are both functions related to managing a shopping cart, but they have different purposes.

addNewPackageToCart is a function that adds a new package to the cart when one of the buttons on add-on-packages.liquid is clicked. This function takes as input the details of the package, such as the name, description, and price, and adds this package to the cart.

On the other hand, updatePackagesOnCartUpdates is a function that updates the packages in the cart when there are changes to the cart. This function takes as input the updated cart details, such as the package quantities and prices, and updates the packages in the cart accordingly. This function is typically used when a user modifies the items in their shopping cart, such as changing the quantity of a particular package or removing a package altogether.

In summary, addNewPackageToCart adds a new package to the cart, while updatePackagesOnCartUpdates updates the packages in the cart when there are changes made to the cart.
*/

var installationTypeOneSKUs = [
  "PSPR",
  "PSSS",
  "PSTM",
  "PSRM",
  "PSEB",
  "PSCV",
  "PSET",
  "PSLP",
  "PSPA9983",
  "PSPA5027",
  "PSPA0407",
  "PSPA4900",
  "PSPA5009",
  "PSPA9979",
  "PSPA9978",
  "PSPA9980",
  "PSPA5028"
];

var installationTypeTwoSKUs = ["PSMA"];

var installationTypeThreeSKUs = ["PSPA"];

var serviceTypeOneSKUs = [
  "PSPR",
  "PSSS",
  "PSPA",
  "PSTM",
  "PSRM",
  "PSEB",
  "PSCV",
  "PSET",
  "PSLP",
];
var serviceTypeTwoSKUs = [
  "PSPR",
  "PSSS",
  "PSPA",
  "PSTM",
  "PSRM",
  "PSEB",
  "PSCV",
  "PSET",
  "PSLP",
];

var installationTypeOneRanges = {
  "1-2": 43345641930906, //"PSINST2"
  "3-5": 43345647665306, //"PSINST3"
  "6-12": 43345655201946, //"PSINST4"
  "13-20": 43345679089818, //"PSINST5"
};
var installationTypeTwoRanges = {
  "1-199": 43345686888602, //"PSINST6"
  "200-299": 43345983406234, //"PSINST7"
  "300-399": 43345983439002, //"PSINST8"
  "400+": 43345983471770, //"PSINST9"
};
var installationTypeThreeRanges = {
  "1-5": 43345647665306, //"PSINST3"
  "6-12": 43345655201946, //"PSINST4"
  "13-20": 43345679089818, //"PSINST5"
};

//ANNUAL VISIT
var serviceTypeOneRanges = {
  "3-5": 43345983537306, //"PSSER1"
  "6-12": 43345983570074, //"PSSER2"
  "13-20": 43345983635610, //"PSSER3"
  "21-48": 43345983668378, //"PSSER4"
};

//2 YEAR SERVICE PACKAGE
var serviceTypeTwoRanges = {
  "3-5": 43345983701146, //"PSSER5"
  "6-12": 43345983733914, //"PSSER6"
  "13-20": 43345983766682, //"PSSER7"
  "21-48": 43345983799450, //"PSSER8"
};

var typeToPackageMap = {
  "inst-type-1": [installationTypeOneSKUs, installationTypeOneRanges],
  "inst-type-2": [installationTypeTwoSKUs, installationTypeTwoRanges],
  "inst-type-3": [installationTypeThreeSKUs, installationTypeThreeRanges],
  "serv-type-1": [serviceTypeOneSKUs, serviceTypeOneRanges],
  "serv-type-2": [serviceTypeTwoSKUs, serviceTypeTwoRanges],
};

function checkCartContents(cartHasPackage, cartItems, productRanges) {
  for (const key of Object.keys(productRanges)) {
    cartHasPackage = cartItems.some(
      (item) => item.variant_id === productRanges[key]
    );

    if (cartHasPackage === true) {
      return cartHasPackage;
    }
  }
}

//define callback function to check cart quantities for relevant products taken from productRanges object
function checkCartQuantities(
  productSkuArray,
  findRelevantPackage,
  productRanges,
  packageSKU,
  cartItems
) {
  let relevantProducts = [];
  let totalQuantity;
  for (const item of cartItems) {
    for (const sku of productSkuArray) {
      if (item.sku.startsWith(sku)) {
        relevantProducts.push(item);
      }
    }
  }

  if (relevantProducts.length > 0) {
    totalQuantity = relevantProducts.reduce(
      (total, item) => total + item.quantity,
      0
    );
  }

  packageSKU = findRelevantPackage(productRanges, totalQuantity, packageSKU);
  return packageSKU;
}

//define function to find the relevant package to add to cart depending on the quantities of items the cart
function findRelevantPackage(productRanges, totalQuantity, packageSKU) {
  Object.keys(productRanges).forEach((key) => {
    console.log(key)
    let arr;
    if (key.includes("-")) {
      arr = key.split("-");
      if (
        totalQuantity >= parseInt(arr[0]) &&
        totalQuantity <= parseInt(arr[1])
      ) {
        packageSKU = productRanges[key];
        console.log(packageSKU);
      }
    } else if (key.includes("+")) {
      arr = key.split("+");
      if (totalQuantity >= parseInt(arr[0])) {
        packageSKU = productRanges[key];
      }
    }
  });

  return packageSKU;
}

function addToCart(packageSKUs) {
  if (packageSKUs.length > 0) {
    let packagesToAdd = [];
    for (const item of packageSKUs) {
      let obj = {};
      obj.id = item;
      obj.quantity = 1;
      packagesToAdd.push(obj);
    }

    // Remove duplicate objects based on id
    let uniquePackages = [];
    packagesToAdd.forEach((pkg) => {
      if (!uniquePackages.some((p) => p.id === pkg.id)) {
        uniquePackages.push(pkg);
      }
    });

    //console.log("unique", uniquePackages);
    let formData = {
      items: uniquePackages,
    };
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (window.location.pathname.includes("cart")) {
          //  console.log("this is running");
          window.location.reload();
        }

        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

function addNewPackageToCart(productSkuArray, productRanges) {
  // Get the cart contents using the Shopify Cart API
  fetch("/cart.json")
    .then((response) => response.json())
    .then((data) => {
      const cartItems = data.items;

      //check if the cart already contains a package
      let cartHasPackage = false;

      cartHasPackage = checkCartContents(
        cartHasPackage,
        cartItems,
        productRanges
      );

      if (!cartHasPackage) {
        // Check if cart contains relevant products and determine the package SKU to add, then add this to cart
        let packageSKU;
        packageSKU = checkCartQuantities(
          productSkuArray,
          findRelevantPackage,
          productRanges,
          packageSKU,
          cartItems
        );
        let packageSKUs = [packageSKU];
        addToCart(packageSKUs);
      } else {
        let currentPackageSKU;
        Object.keys(productRanges).forEach((key) => {
          for (const item of cartItems) {
            if (item.variant_id === productRanges[key]) {
              currentPackageSKU = productRanges[key];
            }
          }
        });

        //remove package
        const url = window.Shopify.routes.root + "cart/update.js";

        const updates = {
          [currentPackageSKU]: 0,
        };

        fetch(url, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: updates,
          }),
        })
          .then((response) => {
            if (response.ok) {
              return response.json();
            } else {
              throw new Error("Network response was not ok.");
            }
          })
          .then((data) => {
            //  console.log(data);
            // Check if cart contains relevant products and determine the package SKU to add, then add this to cart
            let packageSKU;
            packageSKU = checkCartQuantities(
              productSkuArray,
              findRelevantPackage,
              productRanges,
              packageSKU,
              cartItems
            );
            let packageSKUs = [packageSKU];
            if (packageSKU != undefined) {
              addToCart(packageSKUs);
            }
          })
          .catch((error) => console.error("Error:", error));
      }
    });
}

function updatePackagesOnCartUpdate() {
  //get the cart

  fetch("/cart.json")
    .then((response) => response.json())
    .then((data) => {
      const cartItems = data.items;
      // console.log(cartItems);
      //check that there is/are (a) package(s) in the cart

      let cartHasPackage = false;
      let activePackages = [];
      for (const key in typeToPackageMap) {
        const productRanges = typeToPackageMap[key][1];

        cartHasPackage = checkCartContents(
          cartHasPackage,
          cartItems,
          productRanges
        );
        if (cartHasPackage === true) {
          //keep a log of active packages
          activePackages.push(key);
        }
      }

      //console.log(activePackages);

      if (activePackages.length > 0) {
        //remove packages
        let currentPackageSKUs = {};
        for (const package of activePackages) {
          Object.keys(typeToPackageMap[package][1]).forEach((key) => {
            for (const item of cartItems) {
              if (item.variant_id === typeToPackageMap[package][1][key]) {
                currentPackageSKUs[typeToPackageMap[package][1][key]] = 0;
              }
            }
          });
        }

        // console.log("currentSKUs", currentPackageSKUs);
        //remove package
        const url = window.Shopify.routes.root + "cart/update.js";

        const updates = currentPackageSKUs;

        fetch(url, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: updates,
          }),
        })
          .then((response) => {
            if (response.ok) {
              return response.json();
            } else {
              throw new Error("Network response was not ok.");
            }
          })
          .then((data) => {
            // console.log(data);
            // Check if cart contains relevant products and determine the package SKU to add, then add this to cart
            let packageSKUs = [];

            for (const package of activePackages) {
              const packageInfo = typeToPackageMap[package];
              let packageSKU;
              packageSKU = checkCartQuantities(
                packageInfo[0],
                findRelevantPackage,
                typeToPackageMap[package][1],
                packageSKU,
                cartItems
              );
              packageSKUs.push(packageSKU);
            }
            // console.log("readd Package Skus", packageSKUs);
            addToCart(packageSKUs);
          })
          .catch((error) => console.error("Error:", error));
      } else {
        if (window.location.pathname.includes("cart")) {
          // console.log("this is running");

          window.location.reload();
        }
      }

      //remove packages
      //readd packages from log with new quantity ranges
    });
}

function updateWarrantyQuantity(
  newQuantity,
  timestamp,
  updatePackagesOnCartUpdate
) {
  const warrantyProductEl = document.querySelector(
    `[data-timestamp="${timestamp}"][data-related-variant-id] quantity-input`
  );
  if (warrantyProductEl) {
    warrantyProductEl.style.pointerEvents = "none";
    warrantyProductEl.style.opacity = 0.5;
    const qtyButtons = warrantyProductEl.querySelectorAll("button");
    for (const button of qtyButtons) {
      qtyButtons.disabled = true;
    }
  }

  fetch("/cart.json")
    .then((response) => response.json())
    .then((data) => {
      const cartItems = data.items;

      let productHasWarranty = false;

      for (const item of cartItems) {
        for (let i = 1; i < 9; i++) {
          if (item.sku === `PSEXWA${i}`) {
            // warranty SKU's
            productHasWarranty = true;
            break;
          }
        }
      }

      let warranties = [];
      for (const item of cartItems) {
        for (let i = 1; i < 9; i++) {
          if (item.sku === `PSEXWA${i}`) {
            warranties.push(item);
          }
        }
      }

      console.log("productHasWarranty", productHasWarranty);

      let warrantyHasProduct = false;
      for (const warranty of warranties) {
        for (const item of cartItems) {
          if (
            warranty.properties._related_variant_id &&
            parseInt(warranty.properties._related_variant_id) ===
              item.variant_id
          ) {
            warrantyHasProduct = true;
            break;
          }
        }
      }
      let updates = {};
      for (const warranty of warranties) {
        for (const item of cartItems) {
          if (item !== warranty) {
            if (item.properties._timestamp === warranty.properties._timestamp) {
              if (timestamp === warranty.properties._timestamp) {
                if (parseInt(newQuantity) <= parseInt(warranty.quantity)) {
                  updates[`${warranty.variant_id}`] = parseInt(newQuantity);
                }
              }
            }
          }
          if (warrantyHasProduct === false) {
            updates[`${warranty.variant_id}`] = 0;
          }
        }
      }

      if (productHasWarranty) {
        //update cart so that if the new quantity of the product the warranty is for is lower than the number of extended warranties then this is updated to match
        const url = window.Shopify.routes.root + "cart/update.js";
        console.log(updates);
        fetch(url, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: updates,
          }),
        }).then((response) => {
          if (response.ok) {
            updatePackagesOnCartUpdate();
            return response.json();
          } else {
            throw new Error("Network response was not ok.");
          }
        });
      } else {
        updatePackagesOnCartUpdate();
      }
    });
}
